import {mapActions} from "vuex";

export default {
    methods: {
        ...mapActions('menu', [
            'disableSingleSearch'
        ]),
        resetSingleSearch() {
            this.disableSingleSearch()
        }
    },
    mounted() {
        this.resetSingleSearch()
    }

}
